import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Lock } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_API_URL;


const AdminLogin = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post(`${BACKEND_URL}/api/admin/login`, credentials);
      localStorage.setItem('avex_admin_token', response.data.token);
      localStorage.setItem('avex_admin_username', response.data.username);
      navigate('/admin');
    } catch (err) {
      setError('Invalid username or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F9F7] flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Logo */}
        <div className="text-center mb-8">
          <img 
            src="/assets/avex-logo.png" 
            alt="Avex Enterprises" 
            className="h-16 mx-auto mb-4"
          />
          <h1 className="font-heading text-2xl font-bold" data-testid="admin-login-title">Admin Panel</h1>
        </div>

        {/* Login Form */}
        <div className="bg-white p-8 border border-[#E5E5E5]">
          <div className="flex items-center justify-center mb-6">
            <div className="w-16 h-16 bg-[#BFA15F] rounded-full flex items-center justify-center">
              <Lock className="h-8 w-8 text-white" />
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium mb-2" htmlFor="username">
                Username
              </label>
              <input
                id="username"
                type="text"
                value={credentials.username}
                onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                className="w-full border-b border-[#E5E5E5] focus:border-[#BFA15F] bg-transparent px-0 py-2 focus:outline-none focus:ring-0 transition-colors"
                required
                data-testid="admin-username-input"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2" htmlFor="password">
                Password
              </label>
              <input
                id="password"
                type="password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                className="w-full border-b border-[#E5E5E5] focus:border-[#BFA15F] bg-transparent px-0 py-2 focus:outline-none focus:ring-0 transition-colors"
                required
                data-testid="admin-password-input"
              />
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 text-sm" data-testid="admin-login-error">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#BFA15F] text-white hover:bg-[#A68B4F] py-3 uppercase tracking-widest text-sm font-medium transition-all duration-300 disabled:opacity-50"
              data-testid="admin-login-submit"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <a href="/" className="text-sm text-[#888888] hover:text-[#BFA15F] transition-colors">
              ← Back to Website
            </a>
          </div>
        </div>

        <div className="mt-6 text-center text-sm text-[#888888]">
          <p>Default credentials: admin / avex2024</p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;